import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.am{align-items:flex-start;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.d7{background:var(--palette-white);}.ssr-plugin'
import '.q{flex-direction:row;}.ssr-plugin'
import '.fh{justify-content:flex-start;}.ssr-plugin'
import '.h3{gap:2.5rem;}.ssr-plugin'
import '.bg{flex-wrap:wrap;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e am c d7"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d q fh am h3 bg"
      >
        {items.map((item, index) => (
          <div className="d e r s"
            key={index}
          >
            {/* Total Number */}
            <Title.H1
              style={{
                fontSize: '4rem',
                fontWeight: '700',
                lineHeight: '100%',
                margin: 0,
                color: 'var(--brand-secondary)',
                fontFamily: 'FunnelDisplay',
              }}
            >
              {item.total}
            </Title.H1>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
